import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './FootPrintApiManager.types'

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_translate_sales_order_from_public_to_footprint_flowService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { public_materials: $types.FootPrintApiManager.public_material[] }): Promise<{ footprint_materials: $types.Materials.Material[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.public_materials)) {
      missingRequiredInParams.push('\'public_materials\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootPrintApiManager/functions/translate_sales_order_from_public_to_footprint_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

